<template src="./html/IncidentReports.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import FileSaver from 'file-saver'

	import Create from './../views/Create.vue'

	export default {
		props: ['user', 'isAuth', 'data'],
		components: {
			'create': Create,
		},
		data () {
			return {
				incidents: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/projects/tasks/' + this.data.id + '/incidents')
					.then(response => {
						this.incidents = response.body
					})
			},
			reload() {
				this.getData();
			},
			downloadMedia(incident, media) {
				var loading = Ladda.create(document.querySelector('#btn-download-media-'+media.id))
				loading.start()
				this.$http.get('admin/incident/reports/' + incident.id + '/media/' + media.id + '/download', {responseType: 'blob'})
				.then(response => {
					loading.stop()
					var file = response.body
					var blob = new Blob([file], {type: media.mime_type});
					var file_name = media.filename + '.' + media.extension
					FileSaver.saveAs(blob, file_name);
				}).catch(function(response) {
					console.log(response)
					loading.stop()
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/tasks/components/incidentReports/layout/IncidentReports.vue